module.exports = __webpack_public_path__ + "static/media/data-track.46011460.svg";